import React, {Component} from 'react';
import {connect} from "react-redux";
import './Campaign.css';
import {get, objectToFormData} from '../../utils/api'
import {createCampaign, deleteCampaign, updateCampaign} from "../../actions/campaignActions";
import Loading from "../Shared/Loading";
import {withRouter} from 'react-router-dom';
import Select from 'react-select';
import {push} from "connected-react-router";
import lock from '../../assets/lock-480x480.png';
import AutoSuggestContainer from '../AutoSuggest/AutoSuggestContainer';

const createOption = (label) => ({
    label,
    value: label,
});

class CampaignModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            inputOptions: {
                brand: [],
                name: [],
                sellers: [],
                subcategory: [],
                verticals: [],
                designers: [],
                functionalities: [],
                creative_types: [],
                demo_types: [],
                thumbnail_device_types: []
            },
            readOnlyValues: {
                id: false,
            },
            inputValues: {
                brand: {},
                hide_brand: 0,
                name: {},
                seller: {},
                subcategory: [],
                verticals: [],
            },
            steps: 1,
            redirect: false,
            vertical_error: '',
            errors: [],
            showModal: {
                unit: false,
            },
        };

        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleCreate = this.handleCreate.bind(this);
        this.deleteCampaign = this.deleteCampaign.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.handleMultiCheckboxChange = this.handleMultiCheckboxChange.bind(this);

        this.getCampaign = this.getCampaign.bind(this);
        this.getBrand = this.getBrand.bind(this);
        this.getSeller = this.getSeller.bind(this);
    }

    closeModal(e) {
        if (e.keyCode === 27) {
            this.props.toggleModal('campaign', false);
        }
    }

    componentWillUnmount() {
        // console.log("unmount")
        // document.removeEventListener('keydown', this.closeModal);
    }

    componentDidMount() {
        document.addEventListener('keydown', this.closeModal);
        if (this.props.create) {
            if (typeof this.props.brand !== 'undefined') {
                let inputValues = Object.assign({}, this.state.inputValues);
                inputValues.brand = {
                    id: this.props.brand.id,
                    label: this.props.brand.name,
                    value: this.props.brand.name,
                };
                inputValues.hide_brand = this.state.hide_brand;
                this.setState({
                    inputValues : inputValues
                })
            }
        }
        if (!this.props.create || this.props.flow) {
            let campaign = !this.props.create ? this.props.campaign.campaign : this.state.inputValues;
            this.setState({
                readOnlyValues: {
                    id: this.props.prevCampaign.id
                },
                inputValues: {
                    name: {
                        id: Object.keys(this.props.prevCampaign).length === 0 ? campaign.id : this.props.prevCampaign.id,
                        label: Object.keys(this.props.prevCampaign).length === 0 ?  campaign.name : this.props.prevCampaign.name,
                        value: Object.keys(this.props.prevCampaign).length === 0 ?  campaign.name : this.props.prevCampaign.name,
                    },
                    brand: {
                        id: Object.keys(this.props.prevCampaign).length === 0 ? this.props.brand !== undefined ? this.props.brand.id : campaign.brand_id : this.props.prevCampaign.brand_id,
                        label: Object.keys(this.props.prevCampaign).length === 0 ?  this.props.brand !== undefined ? this.props.brand.name : campaign.brand_value : this.props.prevCampaign.brand_value,
                        value: Object.keys(this.props.prevCampaign).length === 0 ?  this.props.brand !== undefined ? this.props.brand.name : campaign.brand_value : this.props.prevCampaign.brand_value,
                    },
                    seller: {
                        id: Object.keys(this.props.prevCampaign).length === 0 ?  campaign.seller_id : this.props.prevCampaign.seller_id,
                        label: Object.keys(this.props.prevCampaign).length === 0 ?  campaign.seller_value : this.props.prevCampaign.seller_value,
                        value: Object.keys(this.props.prevCampaign).length === 0 ?  campaign.seller_value : this.props.prevCampaign.seller_value,
                    },
                    hide_brand:   Object.keys(this.props.prevCampaign).length === 0 ? 0 : this.props.prevCampaign.hide_brand,
                    subcategory: Object.keys(this.props.prevCampaign).length === 0 ? campaign.subcategory : this.props.prevCampaign.subcategory,
                    verticals: Object.keys(this.props.prevCampaign).length === 0 ? campaign.verticals : this.props.prevCampaign.verticals
                }
            });
        }
        // this.handleSubmit.bind(this);
        // $("html, body").animate({ scrollTop: 0 }, 300);
    }
    handleSubmit = (e) => {
        e.preventDefault();
        let inputValues = Object.assign({}, this.state.inputValues);
        const data = objectToFormData(inputValues);
        this.props.dispatch(updateCampaign(this.props.campaign.campaign.id, data)).then(res => {
            this.props.getBannerInfo(res.data.message);
            this.props.toggleModal('campaign', false);
        }, err => {
            this.setState({
                errors: err.error_stack
            });
        });
    };
    handleChange = (name, newValue) => {
        let inputValues = this.state.inputValues;
        inputValues[name] = newValue;
        this.setState({
            inputValues
        });
    };

    handleCreate = (name, inputValue) => {
        const newOption = createOption(inputValue);
        let inputValues = this.state.inputValues;
        inputValues[name] = newOption;
        this.setState({
            inputValues: inputValues
        });
    };
    toggleModal = (type, show) => {
        this.setState({
            showModal: {
                [type]: show
            }
        })
    };
    changeStep = (step) => {
        let errors = [];
        if(this.state.inputValues.seller.value === "" || this.state.inputValues.seller.value === undefined){
            errors.push('Please select a Seller name.')
        }
        if(Object.keys(this.state.inputValues.name.label).length === 0 || this.state.inputValues.name.value === undefined){
            errors.push('Please select a Campaign name.')
        }
        if(this.state.inputValues.brand.id === undefined && this.state.inputValues.verticals.length <= 0){
            if(this.state.inputValues.brand.value === undefined){
                errors.push('Please select a Brand name or create a new one.')
            }
            let vertical_error = "Please select at least 1 vertical";
            errors.push(vertical_error)
        }
        if(this.state.inputValues.brand.value !== undefined && Object.keys(this.state.inputValues.brand.value).length === 0){
            errors.push('Please select a Brand name or create a new one.')
        }
        if(errors.length > 0){
            this.setState({
                errors
            })
        }else{
            this.props.getCampaignValues(this.state.inputValues, step, 'campaign');
            this.setState({
                steps: step,
            })
        }
    }

    handleMultiCheckboxChange(e) {
        const {name, checked} = e.target;
        const value = parseInt(e.target.value);
        let inputValues = this.state.inputValues;
        let arr = inputValues[name];
        let vertical_error = "";
        if (checked) {
            arr = [...arr, value];
        } else {
            arr = arr.filter(el => el !== value);
        }
        if(arr.length === 1 && arr.includes(60)){
            vertical_error = "Error, please choose an additional vertical"
        }

        inputValues[name] = arr;
        this.setState({
            inputValues: inputValues,
            vertical_error: vertical_error,
            errors: false
        });
    }
    handleCheckboxChange = (e) => {
        const {name, checked, value} = e.target;
        let inputValues = Object.assign({}, this.state.inputValues);

        inputValues[name] = checked ? 1 : 0;
        this.setState({inputValues});
    }

    deleteCampaign() {
        const res = window.confirm('Are you sure you want to delete the campaign? All associated units will be deleted.');
        let id = this.props.campaign.campaign.id;
        let brandId= this.props.campaign.campaign.brand_id;
        if (res) {
            this.props.dispatch(deleteCampaign(id));
            this.props.toggleModal('campaign', false);
            this.props.dispatch(push('/brand/' + brandId));
        }
    }
    getBrand(){
        let obj = {}
        if(!this.props.create){
            let campaign = this.props.campaign.campaign;
            obj = {
                id: campaign.brand_id,
                value: campaign.brand_value
            }
        }
        if(this.props.flow){
            let prevCamp_id = Object.keys(this.props.prevCampaign).length === 0 ? "" : this.props.prevCampaign.brand_id;
            let prevCamp_value = Object.keys(this.props.prevCampaign).length === 0 ? "" : this.props.prevCampaign.brand_value;
            obj = {
                id: prevCamp_id,
                value: prevCamp_value
            }
        }
        if(this.props.brand){
            obj = {
                id: this.props.brand.id,
                value: this.props.brand.name
            }
        }
        return obj
    }
    getCampaign(){
        let obj = {}
        if(!this.props.create){
            let campaign = this.props.campaign.campaign;
            obj = {
                id: campaign.id,
                value: campaign.name
            }
        }
        if(this.props.flow){
            let prevCamp_id = Object.keys(this.props.prevCampaign).length === 0 ? "" : this.props.prevCampaign.id;
            let prevCamp_name = Object.keys(this.props.prevCampaign).length === 0 ? "" : this.props.prevCampaign.name;
            obj = {
                id: prevCamp_id,
                value: prevCamp_name
            }
        }

        return obj
    }
    getSeller(){
        let obj = {}
        if(!this.props.create){
            let campaign = this.props.campaign.campaign;
            obj = {
                id: campaign.seller_id ? campaign.seller_id : '',
                value: campaign.seller_value ? campaign.seller_value : ''
            }
        }

        if(this.props.flow){
            let prevCamp_id = Object.keys(this.props.prevCampaign).length === 0 ? "" : this.props.prevCampaign.seller_id;
            let prevCamp_value = Object.keys(this.props.prevCampaign).length === 0 ? "" : this.props.prevCampaign.seller_value;
            obj = {
                id: prevCamp_id,
                value: prevCamp_value
            }
        }
        return obj
    }

    handleKeyDown = name => e => {
        const {inputValue} = this.state;
        if (!inputValue) return;
        let inputValues = Object.assign({}, this.state.inputValues);
        inputValues[name] = inputValues[name];
        switch (e.key) {
            case 'Enter':
            case 'Tab':
                this.setState({
                    inputValue: '',
                });
                e.preventDefault();
        }
    };

    handleSelectChange = (name, idx = false, key = false) => newValue => {
        let inputValues = Object.assign({}, this.state.inputValues);
        if (idx !== false && key !== false) {
            inputValues[name][idx][key] = newValue;
        } else {
            inputValues[name] = newValue;
        }
        this.setState({
            inputValues
        });
    };

    render() {
        const { brand, name, seller, verticals } = this.state.inputValues;
        const enabled = brand.value !== undefined && name.value !== undefined && seller.value !== undefined;

        return (
                <div>
                    <div className="modal-header">
                        <h1>{this.props.create ? 'Add' : 'Edit'} Campaign</h1>
                        <p>Please enter the below details</p>
                    </div>
                    <form>
                        {/*<form method="POST" onSubmit={this.handleSubmit}>*/}
                        {this.state.errors &&
                            <ul className="error-list">
                                {this.state.errors.map((error, key) => (
                                    <li key={key}>{error}</li>
                                ))}
                            </ul>
                        }
                        <div className="campaign-body">
                            <div className="left">
                                <div className="form-group">
                                    <label htmlFor="brand">Brand Name</label>
                                    <div className="brand-campaign-input-wrapper">
                                       <AutoSuggestContainer
                                        suggestions={this.props.inputOptions.brands}
                                        create={this.props.create}
                                        option={'brand'}
                                        prevInfo={this.getBrand()}
                                        handleChange={this.handleChange}
                                        handleCreate={this.handleCreate}/>
                                        {typeof this.state.inputValues.brand.value === 'string' &&  this.state.inputValues.brand.value.trim() !== ''  && typeof this.state.inputValues.brand.id === 'undefined' &&
                                            <div className="hide_brand_container">
                                                <label><input type="checkbox" name="hide_brand" checked={this.state.inputValues.hide_brand} onChange={this.handleCheckboxChange}/><img id="icon-hidden-brand" src={lock} alt="brand is hidden"/>Hide brand</label>
                                            </div>
                                        }
                                    </div>
                                </div>

                                {
                                    typeof this.state.inputValues.brand.value === 'string' &&  this.state.inputValues.brand.value.trim() !== ''  && typeof this.state.inputValues.brand.id === 'undefined' &&  <div className="form-group">
                                        <div className="campaign-vertical">
                                            <div className="form-group">
                                                <label htmlFor="campaign">Brand Vertical <br />Select all that apply </label>
                                                {this.state.vertical_error !== "" &&
                                                    <span className="vertical_warning"> {this.state.vertical_error}</span>
                                                }

                                                <div>
                                                    <ul>
                                                        {this.props.inputOptions.verticals.map((vertical, i) => {
                                                            return <li key={i}><label><input type="checkbox" name="verticals"
                                                                                             value={vertical.id}
                                                                                             defaultChecked={this.state.inputValues.verticals !== undefined ? this.state.inputValues.verticals.includes(vertical.id) : ""}
                                                                                             onChange={this.handleMultiCheckboxChange}/> {vertical.name}
                                                            </label></li>
                                                        })}
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                }
                                <div className="form-group">
                                    <label htmlFor="campaign">Campaign Name</label>
                                    <AutoSuggestContainer
                                      suggestions={this.props.inputOptions.campaigns}
                                      create={this.props.create}
                                      option={'name'}
                                      prevInfo={this.getCampaign()}
                                      handleChange={this.handleChange}
                                      handleCreate={this.handleCreate} />
                                </div>
                                <div className="form-group">
                                    <label htmlFor="seller">Seller</label>
                                    <Select
                                        autoComplete="off"
                                        onChange={this.handleSelectChange('seller')}
                                        options={this.props.inputOptions.sellers}
                                        value={this.state.inputValues.seller === {} ? this.props.prevCampaign.seller_id : this.state.inputValues.seller}
                                        onKeyDown={this.handleKeyDown('seller')}
                                        className="auto-sug"
                                        classNamePrefix="react-select--cat"
                                    />
                                </div>
                                <div className="form-group">
                                    <div className="subcategory-list">
                                        <label htmlFor="">Campaign Subcategory</label>
                                        <div className="category-select">
                                            <Select
                                                autoComplete="off"
                                                isMulti
                                                onChange={this.handleSelectChange('subcategory')}
                                                options={this.props.inputOptions.subcategory}
                                                value={this.state.inputValues.subcategory}
                                                onKeyDown={this.handleKeyDown('subcategory')}
                                                placeholder="optional..."
                                                className="auto-sug"
                                                classNamePrefix="react-select--cat"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                    <div className="button-wrapper">
                        <div className="campaign--action-buttons">
                            <button className="button button--transparent" type="button"
                                    onClick={() => this.props.toggleModal('campaign', false)}>
                                Cancel
                            </button>
                            {this.props.create === false &&
                                <button className="button button--red mr-10 button--red-outline"
                                        onClick={this.deleteCampaign}>Delete Campaign
                                </button>
                            }
                            {this.props.create ?  <button className={`button button--blue ${!enabled ? 'button--disabled' : "" }`} disabled={!enabled} onClick={() => {this.changeStep(2); this.props.changeSteps(2);}}>
                                Next
                            </button> :
                                <button className={`button button--black`} onClick={(e) => this.handleSubmit(e)}>
                                    Update
                                </button>

                            }
                        </div>
                    </div>
                    {this.props.loading && <div className="loading-mask">
                        <Loading/>
                    </div>}
                </div>
        );
    }

}

const mapStateToProps = state => ({
    loading: state.campaign.loading,
});

export default withRouter(connect(mapStateToProps)(CampaignModal));
